import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";
import { ABLETO_THEME_CONFIG } from "./ableto/theme-config";
import { ABWTOFNE_THEME_CONFIG } from "./abwtofne/theme-config";
import { AHPDX_THEME_CONFIG } from "./ahpdx/theme-config";
import { APSOFOH_THEME_CONFIG } from "./apsofoh/theme-config";
import { ARBOROFOH_THEME_CONFIG } from "./arborofoh/theme-config";
import { BBHOFTN_THEME_CONFIG } from "./bbhoftn/theme-config";
import { BHOFDE_THEME_CONFIG } from "./bhofde/theme-config";
import { BHSOLOFMA_THEME_CONFIG } from "./bhsolofma/theme-config";
import { CARECOFMN_THEME_CONFIG } from "./carecofmn/theme-config";
import { CBCOFNC_THEME_CONFIG } from "./cbcofnc/theme-config";
import { CBHOFNE_THEME_CONFIG } from "./cbhofne/theme-config";
import { CBTCOFNC_THEME_CONFIG } from "./cbtcofnc/theme-config";
import { CBTGCOFOH_THEME_CONFIG } from "./cbtgcofoh/theme-config";
import { CCCOFVA_THEME_CONFIG } from "./cccofva/theme-config";
import { CCOFMD_THEME_CONFIG } from "./ccofmd/theme-config";
import { CFPSOFMI_THEME_CONFIG } from "./cfpsofmi/theme-config";
import { CMSFOFAL_THEME_CONFIG } from "./cmsfofal/theme-config";
import { CMSFOFFL_THEME_CONFIG } from "./cmsfoffl/theme-config";
import { CPCCARE_THEME_CONFIG } from "./cpccare/theme-config";
import { DBTCOFTN_THEME_CONFIG } from "./dbtcoftn/theme-config";
import { DBTPTSDOFMN_THEME_CONFIG } from "./dbtptsdofmn/theme-config";
import { DCCOFVA_THEME_CONFIG } from "./dccofva/theme-config";
import { ECASFOROR_THEME_CONFIG } from "./ecasforor/theme-config";
import { EMHOFAZ_THEME_CONFIG } from "./emhofaz/theme-config";
import { ETOFOR_THEME_CONFIG } from "./etofor/theme-config";
import { FCAOFMA_THEME_CONFIG } from "./fcaofma/theme-config";
import { FCAOFNH_THEME_CONFIG } from "./fcaofnh/theme-config";
import { FSSOFNC_THEME_CONFIG } from "./fssofnc/theme-config";
import { HRAOFMI_THEME_CONFIG } from "./hraofmi/theme-config";
import { IBHOFLA_THEME_CONFIG } from "./ibhofla/theme-config";
import { JSTSOFPA_THEME_CONFIG } from "./jstsofpa/theme-config";
import { KPCOFIL_THEME_CONFIG } from "./kpcofil/theme-config";
import { LCCOFIN_THEME_CONFIG } from "./lccofin/theme-config";
import { LIFECHGRP_THEME_CONFIG } from "./lifechgrp/theme-config";
import { LSCOFIN_THEME_CONFIG } from "./lscofin/theme-config";
import { MINDCPENN_THEME_CONFIG } from "./mindcpenn/theme-config";
import { NCCR_THEME_CONFIG } from "./nccr/theme-config";
import { NPAOFMN_THEME_CONFIG } from "./npaofmn/theme-config";
import { OPOFMI_THEME_CONFIG } from "./opofmi/theme-config";
import { OPTUM_THEME_CONFIG } from "./optum/theme-config";
import { PCCOFMI_THEME_CONFIG } from "./pccofmi/theme-config";
import { PHCNY_THEME_CONFIG } from "./phcny/theme-config";
import { RELPRESOL_THEME_CONFIG } from "./relpresol/theme-config";
import { SBROFUT_THEME_CONFIG } from "./sbrofut/theme-config";
import { SPRINGBHNJ_THEME_CONFIG } from "./springbhnj/theme-config";
import { SPRINGBHPENN_THEME_CONFIG } from "./springbhpenn/theme-config";
import { TBTCOFOH_THEME_CONFIG } from "./tbtcofoh/theme-config";
import { TOFMDC_THEME_CONFIG } from "./tofmdc/theme-config";
import { UCCOFOR_THEME_CONFIG } from "./uccofor/theme-config";
import { UPOFIL_THEME_CONFIG } from "./upofil/theme-config";

export const OPTUM_THEME_NAME = "optum" as const;

// THEME_CONFIGS is the single registry for all available themes.
// To add a new theme: import its config and add an entry here.
// You must also add matching public assets under products/web/public/themes/<theme>/
// and update any docs/tests required by current repo conventions.
export const THEME_CONFIGS = {
  [OPTUM_THEME_NAME]: OPTUM_THEME_CONFIG,
  abwtofne: ABWTOFNE_THEME_CONFIG,
  ableto: ABLETO_THEME_CONFIG,
  ahpdx: AHPDX_THEME_CONFIG,
  apsofoh: APSOFOH_THEME_CONFIG,
  arborofoh: ARBOROFOH_THEME_CONFIG,
  bbhoftn: BBHOFTN_THEME_CONFIG,
  bhofde: BHOFDE_THEME_CONFIG,
  bhsolofma: BHSOLOFMA_THEME_CONFIG,
  carecofmn: CARECOFMN_THEME_CONFIG,
  cbcofnc: CBCOFNC_THEME_CONFIG,
  cbhofne: CBHOFNE_THEME_CONFIG,
  cbtcofnc: CBTCOFNC_THEME_CONFIG,
  cbtgcofoh: CBTGCOFOH_THEME_CONFIG,
  cccofva: CCCOFVA_THEME_CONFIG,
  ccofmd: CCOFMD_THEME_CONFIG,
  cfpsofmi: CFPSOFMI_THEME_CONFIG,
  cmsfofal: CMSFOFAL_THEME_CONFIG,
  cmsfoffl: CMSFOFFL_THEME_CONFIG,
  cpccare: CPCCARE_THEME_CONFIG,
  dbtcoftn: DBTCOFTN_THEME_CONFIG,
  dbtptsdofmn: DBTPTSDOFMN_THEME_CONFIG,
  dccofva: DCCOFVA_THEME_CONFIG,
  ecasforor: ECASFOROR_THEME_CONFIG,
  emhofaz: EMHOFAZ_THEME_CONFIG,
  etofor: ETOFOR_THEME_CONFIG,
  fcaofma: FCAOFMA_THEME_CONFIG,
  fcaofnh: FCAOFNH_THEME_CONFIG,
  fssofnc: FSSOFNC_THEME_CONFIG,
  hraofmi: HRAOFMI_THEME_CONFIG,
  ibhofla: IBHOFLA_THEME_CONFIG,
  jstsofpa: JSTSOFPA_THEME_CONFIG,
  kpcofil: KPCOFIL_THEME_CONFIG,
  lccofin: LCCOFIN_THEME_CONFIG,
  lifechgrp: LIFECHGRP_THEME_CONFIG,
  lscofin: LSCOFIN_THEME_CONFIG,
  mindcpenn: MINDCPENN_THEME_CONFIG,
  nccr: NCCR_THEME_CONFIG,
  npaofmn: NPAOFMN_THEME_CONFIG,
  opofmi: OPOFMI_THEME_CONFIG,
  pccofmi: PCCOFMI_THEME_CONFIG,
  phcny: PHCNY_THEME_CONFIG,
  relpresol: RELPRESOL_THEME_CONFIG,
  sbrofut: SBROFUT_THEME_CONFIG,
  springbhnj: SPRINGBHNJ_THEME_CONFIG,
  springbhpenn: SPRINGBHPENN_THEME_CONFIG,
  tbtcofoh: TBTCOFOH_THEME_CONFIG,
  tofmdc: TOFMDC_THEME_CONFIG,
  uccofor: UCCOFOR_THEME_CONFIG,
  upofil: UPOFIL_THEME_CONFIG,
} as const satisfies Record<string, AppThemeConfig>;

// ThemeName is derived from the registry keys so it stays in sync automatically.
export type ThemeName = keyof typeof THEME_CONFIGS;

// Normalizes any incoming tag to a registered ThemeName, falling back to "optum".
export const getThemeNameFromTag = (tag?: string): ThemeName => {
  const normalized = tag?.trim().toLowerCase() ?? "";
  return (Object.hasOwn(THEME_CONFIGS, normalized) ? normalized : OPTUM_THEME_NAME) as ThemeName;
};
